<template>
  <div class="md:hidden">
  </div>

  <div class="min-h-screen w-[90%] mx-auto md:w-full pb-16 md:pb-0">
    <!-- Back -->
    <div class="flex items-center mb-6 md:mb-8">
      <!-- <svg
        @click="goBack"
        class="w-6 h-6 text-[#0C5542] cursor-pointer mr-3  hidden sm:block"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 19l-7-7 7-7"
        />
      </svg> -->

      <!-- Title -->
      <h2 class="text-[22px] md:text-[26px] font-bold text-gray-900  hidden sm:block">
        Terms and Conditions
      </h2>
    </div>

    <!-- Card -->
    <div class="bg-white rounded-xl border border-gray-200
             p-5 md:p-7 mb-6 md:mb-9 shadow-sm
             w-full md:w-auto">
      <h3 class="text-[15px] md:text-[16px] font-semibold text-gray-900 mb-3 md:mb-4">
        Summary of our terms and conditions:
      </h3>

      <div class="flex flex-col gap-3 md:gap-4">
        <div v-for="(section, index) in privacySections" :key="index" class="pb-1">
          <h4 class="font-bold text-[14px] md:text-[15px] text-gray-900 mb-1">
            {{ section.title }}
          </h4>
          <p class="text-sm text-gray-600 leading-relaxed whitespace-pre-line">
            {{ section.content }}
          </p>
        </div>
      </div>
    </div>

    <!-- Agreement -->
    <div class="mb-6 md:mb-8">
      <h3 class="text-sm md:text-lg font-medium text-[#111111] mb-3 md:mb-4">
        I hereby agree that:
      </h3>

      <ol class="ml-5 mb-3 md:mb-4 list-decimal text-sm md:text-base text-[#626363] leading-relaxed">
        <li>
          Consent for Access and Processing of Data for Hamara Mall Transactions:
        </li>
      </ol>

      <div class="bg-[#D1E7DD] rounded-lg p-4 md:p-5 space-y-2 md:space-y-3">
        <p class="text-sm md:text-base text-[#828282] leading-relaxed">
          <span class="text-[#828282] font-normal">[a]</span> By proceeding, I provide my consent to
          <span class="font-semibold">Hamara Mall</span> to enable access to and facilitate my transactions on
          <span class="font-semibold">the platform</span>, including browsing products, placing orders, availing offers,
          and completing purchases through integrated partners and services.
        </p>

        <p class="text-sm md:text-base text-[#828282] leading-relaxed">
          <span class="text-[#828282] font-normal">[b]</span> I further agree to the collection and processing of my
          information for the purpose of
          <span class="font-semibold">order fulfillment, payment processing, customer support, and improving my shopping
            experience</span>,
          in accordance with applicable terms and privacy policies.
        </p>
      </div>
    </div>
  </div>

  <!-- Button -->
  <div v-if="isMobile" class="w-full fixed bottom-0 h-[72px] bg-white rounded-t-lg px-4 py-4">
    <div class="w-full max-w-[375px] mx-auto">
      <button @click="navToBack" class="w-full h-[40px] bg-primary text-white font-semibold
               rounded-lg py-2.5">
        GOT IT
      </button>
    </div>
  </div>
</template>



<script setup lang="ts">
import { ref } from 'vue'
const { isMobile } = useDevice();
const navToBack = () => {
  window.history.back();
}
const privacySections = ref([
  {
    title: "Last updated: 3rd Jan 2022",
    content: `
By accessing and using this site, you accept the following terms and conditions, without limitation or qualification:

1. These Terms of Service (“Terms”, “Terms of Service”) govern your use of this website (“Platform/Website”) operated by nStore Technologies Private Limited (“NTPL”, “we”, “our”, “us”). These Terms apply to all visitors, users and others who wish to access or use the Website.

2. Please carefully go through these Terms of Service and other policies in the Website, before you (“You/Customer, User”) decide to access the Website or avail the services made available on the Website by us.

3. By using this Website or other Services provided by us (“Services”), you acknowledge that you have read these Terms of Service, that you irrevocably accept all the conditions stipulated in the Terms of Use, Privacy Policy, Cookie Policies and other policies (collectively “Policies”) as available on the Website and agree to abide by them.

4. You agree to comply with and be bound by these terms and conditions (“Terms of Use”), which together with our privacy policy (“Privacy Policy”) govern NTPL’s relationship with You.
`
  },
  {
    title: "5. DEFINITIONS",
    content: `
5.1. “Merchant” shall mean the merchants or the retailer who lists their Products in the Platform for sale.

5.2. “Product” shall mean a tangible/ intangible product or service listed on the Platform for sale.

5.3. “nLincs/nPos/Platform/Application” shall mean and include the link, Website or the application provided by Us to the Merchants to enable the Customers to make payment and purchase the Product.
`
  },
  {
    title: "6. COMMUNICATIONS",
    content: `
By using our Platform/Website, you agree to subscribe to our newsletters, marketing or promotional materials and other information We may send.

However, you may opt out of receiving any, or all, of these communications from Us by following the unsubscribe link or by emailing at support@nstore.in.
`
  },
  {
    title: "7. SERVICES",
    content: `
The Platform is created by NTPL for the benefit of Customers.

By using this Platform/Website, You can order and purchase the Products sold by the Merchant online, get regular updates from the Merchant about offers, reminders, coupons and additional services.
`
  },
  {
    title: "8. PROHIBITED USES",
    content: `
8.1. You may use our Website / Platform only for lawful purposes and in accordance with the Terms. You agree not to use it:

A. In any way that violates any applicable law or regulation.

B. For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content or otherwise.

C. To transmit, or procure the sending of, any advertising or promotional material, including any “junk mail”, “chain letter,” “spam,” or any other similar solicitation.

D. To impersonate or attempt to impersonate us, our employee, another User, or any other person or entity.

E. In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity.

F. To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of Website, or which, as determined by us, may harm or offend NTPL or other Users of Website/ Platform or expose them to liability.

8.2. Additionally, you agree not to:

A. Use Website/ Platform in any manner that could disable, overburden, damage, or impair or interfere with any other Party’s use of Website/ Platform.

B. Use any robot, spider, or other automatic device, process, or means to access the Platform/Website for any purpose.

C. Use any manual process to monitor or copy any of the material on Website or for any other unauthorized purpose without our prior written consent.

D. Use any device, software, or routine that interferes with the proper working of Website/ Platform.

E. Introduce any viruses, trojan horses, worms, logic bombs, or other material which is malicious or technologically harmful.

F. Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of Website, the server on which Website/ Platform is stored, or any server, computer, or database connected to Website.

G. Attack Website/ Platform via a denial-of-service attack or a distributed denial-of-service attack.

H. Take any action that may damage or falsify our reputation.
`
  },
  {
    title: "9. REGISTRATION",
    content: `
9.1. By registering for an account through the Application, You represent and warrant that You are the age of majority (age 18).

9.2. You agree to:

A. Provide true, correct, accurate and current information about yourself.

B. Maintain the security of your passwords and identification.

C. Promptly update the email address listed in connection with your account to keep it accurate so that we can contact You at any point in time.

D. Be fully responsible for all uses of your account. You shall not set up an account on behalf of another individual or entity unless You are authorized to do so.

9.3. You agree to abide by all applicable laws and regulations and are solely responsible for all acts or omissions by You on the Account.

Termination: NTPL reserves the right to modify or discontinue Your account at any time for any material breach under these Terms of Use by You or any other reason at its sole discretion without any liability whatsoever.
`
  },
  {
    title: "10. CONTENT AVAILABLE",
    content: `
NTPL does not make any representations or warranties about the material, data, and information that is or may be shared by Merchants or any other content provider (collectively, the “Content”) which You may have access to as part of the Services, or through your use of this Application.

Under no circumstances, NTPL is liable for any Content, including, but not limited to any infringing Content, any errors or omissions in Content, or for any loss or damage of any kind incurred as a result of the use of any Content posted, transmitted, linked from, or otherwise accessible through or made available via the Application.
`
  },
  {
    title: "11. INTELLECTUAL PROPERTY RIGHT",
    content: `
11.1. Any and all intellectual property rights (“Intellectual Property”) associated with the Website, Application and its contents are the sole property of NTPL. All customised graphics, icons, and other items that appear on the Website/ Application are trademarks, service marks or trade name of NTPL. Except as otherwise expressly authorised by these Terms of Use, You shall not copy, reproduce, modify, amend, lease, loan, sell and/or create derivative works from, upload, transmit, and/or distribute the Intellectual Property of the Website in any way without NTPL’s prior written consent. Except as expressly provided herein, NTPL does not grant to You any express or implied rights to the Intellectual Property of NTPL or that of any third party.

11.2. If you are a copyright owner, or authorized on behalf of one, and you believe that the copyrighted work has been copied in a way that constitutes copyright infringement, please submit your claim via email to support@nstore.in, with the subject line: “Copyright Infringement”.

11.3. You shall be held accountable for damages (including costs and attorneys’ fees) for misrepresentation or claims on the infringement of any Content found on and/or through Service on your copyright.

`
  },


  {
    title: "12. DEALINGS WITH ORGANISATIONS AND INDIVIDUALS:",
    content: `
You acknowledge and agree that NTPL shall not be liable for your interactions with any Merchant on the Platform. This includes, but is not limited to, Services, if any, and any other terms, conditions, warranties, or representations associated with any interaction You may have with other Merchants. You agree and acknowledge that NTPL shall not be responsible or liable for any loss or damage of any sort incurred as the result of any such dealings or interactions. If there is a dispute between Merchant and You, or between You and any third party, you understand and agree that NTPL is under no obligation to become involved in such dispute. If You have a dispute with one or more other Merchant’s, you hereby release NTPL, its officers, employees, agents and successors from any and all claims, demands and damages (actual and consequential) of every kind or nature, known or unknown, suspected and unsuspected, disclosed and undisclosed, arising out of or in any way related to such disputes and/or our Application.
`
  },
  {
    title: "13. CHANGE IN TERMS",
    content: `
NTPL reserves the right change these Terms of Use at any time and to notify You by posting an updated version of the Terms of Use on Platform. You are responsible for regularly reviewing the Terms of Use. Continued use of the Platform after any such changes shall constitute your consent to be bound by such changes. Your only right with respect to any dissatisfaction with these Terms of Use; any policy or practice of ours in operating the Platform or any Content available through the Application, is to stop accessing and using the Application.
`
  },
  {
    title: "14. DISCLAIMER OF WARRANTIES",
    content: `
YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE PLATFORM AND THE SERVICE IS ENTIRELY AT YOUR OWN RISK AND THAT THE PLATFORM AND THE SERVICES THEREIN ARE PROVIDED ON AN “AS IS” OR “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND. ALL EXPRESS AND IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT OF PROPRIETARY RIGHTS ARE EXPRESSLY DISCLAIMED TO THE FULLEST EXTENT PERMITTED BY LAW.

TO THE FULLEST EXTENT PERMITTED BY LAW NTPL, ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE PLATFORM, THE SERVICES AND YOUR USE THEREOF.
NTPL MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES OR THE PLATFORM ‘S CONTENT OR THE CONTENT OF ANY THIRD PARTY WEBSITES LINKED TO THE PLATFORM AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE PLATFORM AND SERVICE, (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION, (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE PLATFORM, (IV) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE PLATFORM BY ANY THIRD PARTY, AND/OR (V) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, COMMUNICATED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE PLATFORM OR THE SERVICE.

NTPL DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE PLATFORM OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND NTPLWILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND/OR OTHER MERCHANTAND/OR THIRD-PARTY SERVICE PROVIDERS.

THE PLATFORM MAY ALSO CONTAIN THIRD PARTY ADVERTISEMENTS, IF ANY. THE DISPLAY OF SUCH ADVERTISEMENTS DOES NOT IN ANY WAY IMPLY AN ENDORSEMENT OR RECOMMENDATION BY OF THE RELEVANT ADVERTISER, ITS PRODUCTS OR SERVICES. YOU ARE REFERRED TO THE RELEVANT ADVERTISER FOR ALL INFORMATION REGARDING THE ADVERTISEMENT AND ITS PRODUCTS AND/OR SERVICES. NTPL ACCEPTS NO RESPONSIBILITY FOR ANY INTERACTION BETWEEN YOU AND THE RELEVANT THIRD PARTY AND IS RELEASED FROM ANY LIABILITY ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH INTERACTION.
`
  },
  {
    title: "15. Cancel, Refund & Delivery Policies",
    content: `
A. The product price displayed is inclusive of applicable taxes unless explicitly stated otherwise.
 
B. Store accepts Cash on Delivery and/or Online payment methods for Payment. However, Store reserves the right not to accept any one of the payment methods without any prior notice.
 
C. Store may charge some delivery fees depending on your location.
 
D. Delivery will be made within 24 hours from the time of order, however, the actual delivery details will be shared directly by the store.
 
E. For Sales returns and refund, you may need to contact the Store with original product purchased from the store. Store reserves the right to accept returns and refund basis the condition of the returned product.
 
F. For any support related queries, please send a mail to support@nstore.in with your registered mobile number and store name.
`
  },
  {
    title: "16. LIMITATION OF LIABILITY",
    content: `
IN NO EVENT SHALL NTPL, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE FOR DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (EVEN IF NTPL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM YOUR USE OF THE PLATFORM OR THE SERVICE, INCLUDING BUT NOT LIMITED TOTHE DAMAGES THAT MAY ARISE FROM YOUR USE OR MISUSE OF THE PLATFORM OR THE SERVICE, FROM INABILITY TO USE THE PLATFORM OR THE SERVICE, OR THE INTERRUPTION, SUSPENSION, MODIFICATION, ALTERATION, OR TERMINATION OF THE PLATFORM OR THE SERVICE.

SUCH LIMITATION OF LIABILITY SHALL ALSO APPLY WITH RESPECT TO DAMAGES INCURRED BY THE USE OF THIRD-PARTY SERVICES OR LINKSADVERTISED IN THE PLATFORM OR THROUGH ANY INFORMATION, OPINION OR ADVICE RECEIVED THROUGH SUCH LINKS OR USE OF SERVICES BY THIRD PARTY

THESE LIMITATIONS SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW. YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT NTPL SHALL NOT BE LIABLE FOR CONTENTS THAT ARE DEFAMATORY, OFFENSIVEOR FOUND ILLEGAL.THE PLATFORM IS CONTROLLED AND OFFERED BY NTPL FROM ITS FACILITIES IN INDIA.
`
  },
  {
    title: "17. INDEMNIFICATION",
    content: `
You agree to indemnify us and hold us harmless from and against any claims arising out of or relating to all actions, proceedings, claims (including third party claims), liabilities (including statutory liability), penalties, charges, demands and costs (including without limitation, legal costs of the other Party), awards, damages, losses and/or expenses however arising directly or indirectly or consequentially suffered or incurred by the User as a result of any breach or non-performance of their respective undertaking/s, warranties:

A. Information, details and content that you submit or transmit for the Services

B. your violation of any rights of other Users in relation with the Application,

C. infringement of any third-party intellectual property rights,

D. any breach of terms and conditions of these Terms of Use,

E. any breach of applicable law.
`
  },
  {
    title: "18. ANTI-SPAM POLICY",
    content: `
You certify that you will use the Services in accordance with these Terms of Use. You are forbidden to transmit unsolicited commercial email (spam) by using the Services. Additionally, You are required to reconfirm (permission pass) or stop mailing an existing list when it is determined to be in violation of our anti-spam policy. Repeated violations or failures to comply with this anti-spam policy will result in termination of your access to the Services. You agree and acknowledge that, we shall not be held liable for any claim that may arise due to your violation of this anti-spam policy.
`
  },
  {
    title: "19. GOVERNING LAW",
    content: `
These Terms of Use are governed and construed according to the laws of India and the Courts in Chennai shall have exclusive jurisdiction to entertain any proceedings in any way relating to or concerning these Terms of Use.
`
  },
  {
    title: "20. FORCE MAJEURE",
    content: `
Without limiting the foregoing, under no circumstances shall NTPL is held liable for any damage or loss due to deficiency in performance of Services resulting directly or indirectly from acts of nature, forces, or causes beyond its reasonable control, including, without limitation to internet failures, computer equipment failures, telecommunication equipment failures, software failures, machinery breakdown, strike, or due to government regulations, floods, storms, pandemic, epidemic, electrical failure, civil disturbances, riots and any other reason beyond reasonable control of the Merchant or the Application.
`
  },
  {
    title: "21. ERROR REPORTING AND FEEDBACK",
    content: `
In case of any technical issues or feedback (“Feedback”), please contact by sending us your queries at support@nstore.in or call us at +91 9444055322. You acknowledge and agree that: (i) you shall not retain, acquire or assert any intellectual property right or other right, title or interest in or to the Feedback; (ii) NTPL may have development ideas similar to the Feedback; (iii) Feedback does not contain confidential information or proprietary information from you or any third party; and (iv) NTPL is not under any obligation of confidentiality with respect to the Feedback. In the event the transfer of the ownership to the Feedback is not possible due to applicable mandatory laws, you grant NTPL and its affiliates an exclusive, transferable, irrevocable, free-of-charge, sub-licensable, unlimited, and perpetual right to use (including copy, modify, create derivative works, publish, distribute and commercialize) Feedback in any manner and for any purpose.
`
  },
  {
    title: "22. OFFERS",
    content: `
Offer is applicable only on selected items, valid for a limited time and subject to availability.
`
  }

])



const goBack = () => {
  console.log('Go back')
}


</script>